var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useContext, useCallback, useRef, } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { initializeI18n } from "./i18n";
import { SampleApp } from "./sample-app/react-ts-sample";
import LoadingMatilda from "./components/Loading/index";
import Leyend from "./components/Leyend/index";
import NotFound from "./components/NotFound/index";
import LoadingFaceTec from "./components/LoadingFaceTec/index";
import { MainProvider, MainContext } from "./context/MainContext";
import useValidation from "./hooks/useValidation";
import constants from "./constants";
var VERSION = process.env.VERSION;
var BasicComponent = function () {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(""), imageUrl = _b[0], setImageUrl = _b[1];
    var _c = useState(null), validToken = _c[0], setValidToken = _c[1];
    var _d = useState(null), i18nInstance = _d[0], setI18nInstance = _d[1];
    var _e = useState(false), showLeyend = _e[0], setShowLeyend = _e[1];
    var _f = useState(false), isFaceTecReady = _f[0], setIsFaceTecReady = _f[1];
    var _g = useState(false), livenessSessionInProgress = _g[0], setLivenessSessionInProgress = _g[1];
    var livenessStartGuardRef = useRef(false);
    var _h = useContext(MainContext), getFromUrl = _h.getFromUrl, apiKeyG = _h.apiKey;
    var _j = useValidation(), getTokenValidation = _j.getTokenValidation, getExternalTokenValidation = _j.getExternalTokenValidation, setEvent = _j.setEvent;
    var facetecInitGuardRef = useRef(false);
    var autoStartOnceRef = useRef(false);
    var onLivenessCheckPressed = useCallback(function () {
        if (!isFaceTecReady) {
            console.warn(i18nInstance.t("connection-error-try-again"));
            return;
        }
        if (livenessStartGuardRef.current)
            return;
        livenessStartGuardRef.current = true;
        setLivenessSessionInProgress(true);
        try {
            setImageUrl("");
            setEvent(constants.START, apiKeyG);
            SampleApp.setExternalConfig(apiKeyG, setEvent);
            SampleApp.onLivenessCheckPressed();
            setShowLeyend(false);
        }
        catch (error) {
            livenessStartGuardRef.current = false;
            setLivenessSessionInProgress(false);
            console.error(error);
        }
    }, [isFaceTecReady, i18nInstance, apiKeyG, setEvent]);
    var validateToken = function (client, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
        var validate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, getTokenValidation(client, apiKey)];
                case 1:
                    validate = _a.sent();
                    setValidToken(validate);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validateExternalToken = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
        var validate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, getExternalTokenValidation(accessToken)];
                case 1:
                    validate = _a.sent();
                    setValidToken(validate);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a = getFromUrl(location), lang = _a.lang, idLogo = _a.idLogo, tokenParam = _a.token, tokenExternal = _a.accessToken, apiKey = _a.apiKey, leyend = _a.leyend;
        if (lang) {
            var newI18n = initializeI18n(lang);
            setI18nInstance(newI18n);
        }
        if (!lang) {
            setLoading(false);
            return;
        }
        if (!tokenParam && !tokenExternal) {
            setLoading(false);
            return;
        }
        if (idLogo) {
            var logoId = SampleApp.setLogoId(idLogo);
            setImageUrl(logoId);
        }
        if (leyend) {
            setShowLeyend(true);
        }
        if (tokenParam && apiKey && !tokenExternal) {
            validateToken(tokenParam, apiKey);
        }
        if (!tokenParam && !apiKey && tokenExternal) {
            validateExternalToken(tokenExternal);
        }
    }, [location]);
    useEffect(function () {
        SampleApp.onFaceTecReady(function () {
            setIsFaceTecReady(true);
        });
    }, []);
    // Inicializa FaceTec SOLO cuando ya tenemos apiKey del cliente.
    useEffect(function () {
        if (facetecInitGuardRef.current)
            return;
        if (!i18nInstance)
            return;
        if (!apiKeyG)
            return;
        facetecInitGuardRef.current = true;
        SampleApp.setExternalConfig(apiKeyG, setEvent);
        SampleApp.initialize();
    }, [apiKeyG, i18nInstance, setEvent]);
    useEffect(function () {
        SampleApp.setOnLivenessSessionEnd(function () {
            livenessStartGuardRef.current = false;
            setLivenessSessionInProgress(false);
        });
        return function () { return SampleApp.setOnLivenessSessionEnd(null); };
    }, []);
    // Auto-start the flow when FaceTec is ready and the token is valid
    useEffect(function () {
        if (autoStartOnceRef.current)
            return;
        if (validToken && isFaceTecReady && i18nInstance && apiKeyG) {
            autoStartOnceRef.current = true;
            var timer_1 = setTimeout(function () {
                onLivenessCheckPressed();
            }, 100);
            return function () { return clearTimeout(timer_1); };
        }
    }, [
        validToken,
        isFaceTecReady,
        i18nInstance,
        apiKeyG,
        onLivenessCheckPressed,
    ]);
    if (!i18nInstance)
        return null;
    return (React.createElement(I18nextProvider, { i18n: i18nInstance },
        !validToken && loading && React.createElement(LoadingMatilda, null),
        !validToken && !loading && React.createElement(NotFound, null),
        validToken && (React.createElement("main", { className: "main" },
            imageUrl != "" ? (React.createElement("img", { src: imageUrl, alt: "logo-company", className: "logo" })) : (React.createElement("div", { className: "without-logo" })),
            React.createElement("div", { className: "wrapping-box-container" },
                React.createElement("div", { id: "controls" },
                    React.createElement("div", { className: "flex-center" },
                        isFaceTecReady ? (React.createElement("button", { id: "liveness-button", className: "unstyle btn-primary", type: "button", disabled: livenessSessionInProgress, onClick: function () { return onLivenessCheckPressed(); } }, i18nInstance.t("continue"))) : (React.createElement(LoadingFaceTec, null)),
                        React.createElement("span", { className: "text-xs text-center", id: "version" }, "".concat(i18nInstance.t("version"), " ").concat(VERSION))),
                    React.createElement("span", { className: "text text-center", id: "status" }))),
            React.createElement(Leyend, { showLeyend: showLeyend })))));
};
var container = document.getElementById("app");
var root = createRoot(container);
root.render(React.createElement(MainProvider, null,
    React.createElement(BasicComponent, null)));
